import React, { useState, useEffect } from 'react';
import { FaInstagram, FaTiktok, FaFacebookF } from 'react-icons/fa';
import Flag from 'react-world-flags';
import { useLanguage } from '../context/LanguageContext';
import '../styles/Navbar.css';
import logo from '../assets/logo.jpg';

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [languageDropdownOpen, setLanguageDropdownOpen] = useState(false);
  const { language, toggleLanguage, t } = useLanguage();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (event, sectionId) => {
    event.preventDefault();
    const target = document.getElementById(sectionId);
    if (target) {
      const offset = 80;
      const elementPosition = target.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
    setMobileMenuOpen(false);
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
    setLanguageDropdownOpen(false);
  };

  const toggleLanguageDropdown = (e) => {
    e.stopPropagation();
    setLanguageDropdownOpen(!languageDropdownOpen);
  };

  const handleLanguageSelect = (lang) => {
    if (language !== lang) {
      toggleLanguage();
    }
    setLanguageDropdownOpen(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest('.language-dropdown')) {
        setLanguageDropdownOpen(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="navbar-container">
        <a href="#home" className="navbar-brand" onClick={(e) => handleNavClick(e, 'home')}>
          <img src={logo} alt="Maya's Flavours Logo" className="navbar-logo" />
          <span className="brand-text">Maya's Flavours</span>
        </a>

        <button
          className={`mobile-menu-toggle ${mobileMenuOpen ? 'active' : ''}`}
          onClick={toggleMobileMenu}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <div className={`navbar-menu ${mobileMenuOpen ? 'active' : ''}`}>
          <a href="#home" className="nav-link" onClick={(e) => handleNavClick(e, 'home')}>
            {t('nav.home')}
          </a>
          <a href="#about" className="nav-link" onClick={(e) => handleNavClick(e, 'about')}>
            {t('nav.about')}
          </a>
          <a href="#gallery" className="nav-link" onClick={(e) => handleNavClick(e, 'gallery')}>
            {t('nav.gallery')}
          </a>
          <a href="#testimonials" className="nav-link" onClick={(e) => handleNavClick(e, 'testimonials')}>
            {t('nav.testimonials')}
          </a>
          <a href="#careers" className="nav-link" onClick={(e) => handleNavClick(e, 'careers')}>
            {t('nav.careers')}
          </a>
          <a href="#contact" className="nav-link" onClick={(e) => handleNavClick(e, 'contact')}>
            {t('nav.contact')}
          </a>

          <div className="nav-social-links">
            <a
              href="https://www.instagram.com/mayas_flavours/"
              target="_blank"
              rel="noopener noreferrer"
              className="nav-social-link"
              aria-label="Instagram"
            >
              <FaInstagram />
            </a>
            <a
              href="https://www.tiktok.com/@mayasflavours"
              target="_blank"
              rel="noopener noreferrer"
              className="nav-social-link"
              aria-label="TikTok"
            >
              <FaTiktok />
            </a>
            <a
              href="https://www.facebook.com/MayasFlavours"
              target="_blank"
              rel="noopener noreferrer"
              className="nav-social-link"
              aria-label="Facebook"
            >
              <FaFacebookF />
            </a>
          </div>

          <div className={`language-dropdown ${languageDropdownOpen ? 'open' : ''}`}>
            <button className="language-toggle" onClick={toggleLanguageDropdown}>
              {language === 'el' ? (
                <>
                  <Flag code="GR" className="flag-icon" />
                  <span>ΕΛ</span>
                </>
              ) : (
                <>
                  <Flag code="GB" className="flag-icon" />
                  <span>EN</span>
                </>
              )}
            </button>
            <div className="language-options">
              <button
                className={`language-option ${language === 'el' ? 'active' : ''}`}
                onClick={() => handleLanguageSelect('el')}
              >
                <Flag code="GR" className="flag-icon" />
                <span>Ελληνικά</span>
              </button>
              <button
                className={`language-option ${language === 'en' ? 'active' : ''}`}
                onClick={() => handleLanguageSelect('en')}
              >
                <Flag code="GB" className="flag-icon" />
                <span>English</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
